/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const Omega = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M14 20v-2.16c1.86-1.19 3.5-3.87 3.5-6.96 0-3.07-2-6.02-5.5-6.02S6.5 7.8 6.5 10.88c0 3.09 1.64 5.77 3.5 6.96V20H3v-2h4.76A8.8 8.8 0 0 1 4 10.88C4 6.25 7.5 3 12 3s8 3.25 8 7.88c0 3.1-1.67 5.63-3.76 7.12H21v2z" />
  </Icon>
);
